var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.257,
    cy: 18.257,
    r: 18.257,
    fill: "#0F141A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1688_12783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1048 17.2218L26.2974 10.0234H24.83L19.453 16.2737L15.1584 10.0234H10.2051L16.6993 19.4749L10.2051 27.0234H11.6726L17.3508 20.423L21.8862 27.0234H26.8395L20.1045 17.2218H20.1048ZM18.0949 19.5581L17.4369 18.617L12.2014 11.1282H14.4554L18.6805 17.1719L19.3385 18.113L24.8306 25.969H22.5766L18.0949 19.5585V19.5581Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1688_12783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(10.0234 10.0234)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.69cc21d658f0b064223c72da36cf2b76.svg";
export { ForwardRef as ReactComponent };